import { PaywallDisplay, setDisplayState } from 'redux/slices/paywall'
import React, { useEffect } from 'react'

import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { faWindowClose } from '@fortawesome/free-solid-svg-icons'
import { isMobile } from 'utils'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import useStyles from './styles'

const PaywallRedemptionSuccess = () => {
    const classes = useStyles()
    const [fadeOut, setFadeOut] = useState(false)
    const dispatch = useDispatch()

    const displayIw = React.useCallback(() => {
        dispatch(setDisplayState(PaywallDisplay.ACCESS))
    }, [dispatch])

    const fadeOutNow = React.useCallback(() => {
        setFadeOut(true)
        displayIw()
    }, [displayIw])

    useEffect(() => {
        let timer = setTimeout(fadeOutNow, 90000)
        return () => clearTimeout(timer)
    }, [fadeOutNow])

    return (
        <div className={clsx(classes.container, fadeOut && [classes.fadeOut])} id="paywall-success-container">
            <div onClick={fadeOutNow} className={classes.close}>
                <FontAwesomeIcon icon={faWindowClose} />
            </div>
            <h3 className={classes.heading}>YOU'RE IN!</h3>
            <p className={classes.subheading}>
                You have successfully redeemed your Confirmation Code and have full access to the event!
            </p>
            <CallToActionButton
                onClick={displayIw}
                type="secondary"
                size={isMobile() ? 'normal' : 'large'}
                display="block"
                text="Enter the event"
                className={classes.submitPassBtn}
                id="paywall-success-toast-btn"
            />
            <p className={classes.subheading}>
                {/*TODO*/}
                Have any questions?{' '}
                <Link to="/support">
                    <span className={classes.subheadingBold}>Visit our support page</span>
                </Link>
            </p>
        </div>
    )
}

export default React.memo(PaywallRedemptionSuccess)
